import React from 'react';
import { handleDawsonDestinationChangeFactory } from '../CommonFunctions';

class ExclusiveSearchForm extends React.Component {

    componentDidMount() {

        const suggestion = {
            code: ['00034', '043', 'D38']
        };

        handleDawsonDestinationChangeFactory(this.props.parent)(suggestion);
    }
    render() {
        return (
            <img
                src={'assets/b2bwebdawson/salou_experience.png'}
                alt="Salou logo" height="48"
            />
        );
    }
}
export default ExclusiveSearchForm;


// WEBPACK FOOTER //
// ./src/components/SearchContent/ExclusiveSearchForms/ExclusiveSearchForm.b2bwebdawson.js